var $blogPosts = $('.js-blog-posts');
var $blogFilter = $('.js-blog-filter');

var $container = $blogPosts.imagesLoaded(function() {
    $blogPosts.isotope({
        itemSelect: '.article',
        layoutMode: 'fitRows'
    });
});

/**
 *
 * @type {jQuery|HTMLElement}
 */
var $checkboxes = $('.js-blog-filter input');
$checkboxes.change(function() {
    var inclusives = [];

    $checkboxes.each(function(i, elem) {

        var elementLabel = $(elem).closest('label');

        // if checkbox, use value if checked
        if (elem.checked) {
            elementLabel.addClass('active');
            inclusives.push(elem.value);
        } else {
            elementLabel.removeClass('active');
        }
    });

    var filterValue = inclusives.length ? inclusives.join(', ') : '*';
    $container.isotope({
        filter: filterValue
    })
});


/**
 * Handle more/less topics
 */
var $moreTopicsButton = $blogFilter.find('.js-more-topics');
var $lessTopicsButton = $blogFilter.find('.js-less-topics');

$moreTopicsButton.on('click', function(event) {

    event.preventDefault();

    $(this).addClass('hidden');
    $lessTopicsButton.removeClass('hidden');
    $blogFilter.find('label.hidden-option').removeClass('hidden');
});

/**
 *
 */
$lessTopicsButton.on('click', function(event) {

    event.preventDefault();

    $(this).addClass('hidden');
    $moreTopicsButton.removeClass('hidden');
    $blogFilter.find('label.hidden-option').addClass('hidden');
});
